import { render, staticRenderFns } from "./BlogPostsSidebarSearch.vue?vue&type=template&id=0dcb790b&scoped=true&"
import script from "./BlogPostsSidebarSearch.vue?vue&type=script&lang=js&"
export * from "./BlogPostsSidebarSearch.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostsSidebarSearch.vue?vue&type=style&index=0&id=0dcb790b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb790b",
  null
  
)

export default component.exports